import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

const Login = ({ firebase }) => {
    const firebaseAuthUiConfig = {
        signInFlow: "popup",
        signInOptions: [
            { provider: firebase.auth.EmailAuthProvider.PROVIDER_ID, requireDisplayName: false },
            { provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID },
        ],
        signInSuccessUrl: "/eco/",
        callbacks: {
            // Avoid redirects after sign-in.
            signInSuccessWithAuthResult: () => false,
        },
    };

    return (
        <>
            <div className="signin-or-register-text">
                <h1>Sign in/Register</h1>
            </div>
            <StyledFirebaseAuth
                uiConfig={firebaseAuthUiConfig}
                firebaseAuth={firebase.auth()}
            />
        </>
    );
};

export default Login;
